import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { deleteAppFile } from "../actions";
import { useActionState, useEffect } from "react";

export function CreateFile() {
  return (
    <Link to={"/admin/app-files/create"} className="contents">
      <Button className="mt-4">
        Create File
        <Icon icon={PlusIcon} label="Create Feature" className="ml-1" />
      </Button>
    </Link>
  );
}


export function Updatefile({ id }: { id: string }) {
  return (
    <Link to={`/admin/app-files/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteFile({ id }: { id: string }) {
  const navigate = useNavigate();

  const deleteAppFileWithId = deleteAppFile.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this file?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteAppFileWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success) {
      navigate(`/admin/app-files?reload=${Date.now()}`, { replace: true });
    }
    else if(state.message){
      alert(state.message);
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}
